import { defer } from 'react-router-dom'
import { mercuryApi } from '$api'

// Defines what data should be loaded for this component, the data in here is
// fetched in parallel with navigating to the route and is then passed to the
// component as a prop.
export default async function loader({ params }) {
  return defer({
    data: mercuryApi.get(`/pay-rules/packages/${params.packageId}`),
  })
}
